import apiClient from "../../../../http-common";
//--------------------Get All Pass Type list--------------------
export const getAllVisitorCompanyList = async (listObject) => {
  return await apiClient.post(`master/visitorCompany/list`, listObject, {
    // headers:authHeader()
  });
};

// searchString
export const VisitorCompanyBySearchString = async (searchString) => {
  return await apiClient.get(`/master/visitorCompany/${searchString}`, {
    // headers:authHeader()
  });
};

// //Delete Record By ID

export const deleteVisitorCompanyById = async (id) => {
  return await apiClient.delete(`/master/visitorCompany/delete/${id}`, {
    // headers:authHeader()
  });
};

//Save
export const saveVisitorCompany = async (finalData) => {
  return await apiClient.post(`/master/visitorCompany/save`, finalData, {
    // headers:authHeader()
  });
};

//update
export const updateVisitorCompany = async (finalData) => {
  return await apiClient.post(`/master/visitorCompany/update`, finalData, {
    // headers:authHeader()
  });
};

// dropdown
export const visitorCompanyDropdown = async () => {
  return await apiClient.get(`master/visitorCompany/dropdown`, {
    // headers:authHeader()
  });
};
